import { FILTER_TYPES } from 'components/FilterPod';

export const STATUS_BRANCH_OPTIONS = [
  {
    value: true,
    label: 'فعال',
  },

  {
    value: false,
    label: 'غیرفعال',
  },
];

const filters = () => [
  {
    title: 'شناسه شعبه',
    label: 'شناسه شعبه',
    keyName: 'businessId',
    query: 'businessId',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نام شعبه',
    label: 'نام شعبه',
    keyName: 'query',
    query: 'query',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'نام کاربری',
    label: 'نام کاربری',
    keyName: 'username',
    query: 'username',
    id: 3,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'ایمیل',
    label: 'ایمیل',
    keyName: 'email',
    query: 'email',
    id: 4,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr' },
  },

  {
    title: 'کد اقتصادی',
    label: 'کد اقتصادی',
    keyName: 'economicCode',
    query: 'economicCode',
    id: 6,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'شناسه ملی',
    label: 'شناسه ملی',
    keyName: 'nationalCode',
    query: 'nationalCode',
    id: 7,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'شماره ثبت',
    label: 'شماره ثبت',
    keyName: 'registrationNumber',
    query: 'registrationNumber',
    id: 8,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'وضعیت شعبه',
    label: 'وضعیت شعبه',
    keyName: 'branchState',
    query: 'branchState',
    id: 9,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_BRANCH_OPTIONS,
    },
  },
  {
    title: 'مالک',
    label: {
      start: 'نام',
      end: 'نام خانوادگی',
    },
    keyName: 'owner',
    id: {
      start: 'ownerFirstName',
      end: 'ownerLastName',
    },
    query: {
      start: 'ownerFirstName',
      end: 'ownerLastName',
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
      },
      end: {
      },
    },
    typeInput: 'string',
  },
];

export default filters;